import { themeRegistry } from '@agilepoint/wat-react-ux';

themeRegistry.registerThemeUsingCompilers('mobile-app-accelerator-default', { layout: { columnsCount: 24 } }, (semantics) => ({
    mobileAppAccelerator: {
        semanticColors: {
            grayVariant2: '#676E7B',
            grayVariant3: '#667287',
            grayVariant4: '#CACED5',
            grayVariant5: '#F1F2F4',
            grayVariant6: '#F8F9FA',
            pageBackgroundColor: '#F8F9FA',
            primaryTextColor: '#676E7B',
            secondaryTextColor: '#3B4455',
            horizontalLineColor: '#667287',
            apStandardBlueColor: '#0077D9',
            notificationBadgeColor: '#B32181;',
            genericBorderColor: '#caced5',
            eyeIconfillColor: '#444444',
            wizard: {
                backgroundColor: semantics.colors.layers.contentBackground,
                stepSeparatorColor: '#CACED5',
                activeStepColor: '#0077D9',
                checkedStepColor: '#667287'
            }
        },
        semantics: {
            popupFooterSeparator: '1px solid #e5e8ee'
        }
    }
}));
